import { PageController } from '@client/components/_core/layout/PageController';
import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { useOrg } from '@client/hooks/business/org/useOrg';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { createFileRoute } from '@tanstack/react-router';
import { Result } from 'antd';
import { CheckCircle } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/financials/billing/payment/success')({
    component: PaymentSuccessful,
});

function PaymentSuccessful() {
    const navigate = useNavigate();
    const org = useOrg();

    const handleBackToBilling = () => {
        navigate({
            to: '/console/$orgId/configuration/financials/billing',
            params: { orgId: org.id },
        });
    };

    return (
        <PageController route={Route}>
            <div className="flex h-full items-center justify-center p-8">
                <Result
                    icon={<CheckCircle className="text-green-500" size={72} />}
                    status="success"
                    title="Payment Successful!"
                    subTitle="Thank you for your payment. Your transaction has been completed successfully."
                    extra={[
                        <Button type="primary" onClick={handleBackToBilling} key="back">
                            Back to Billing
                        </Button>,
                    ]}
                />
            </div>
        </PageController>
    );
}
